import React, {Component} from 'react';
import {Col, Row} from 'antd';
import PropTypes from 'prop-types';
import '../css/card.css';

class Card extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {height, width, align, justify, border, style, children, title, className} = this.props, style2 = {};
        if (height) {
            style2.height = height;
        }
        if (width) {
            style2.width = width;
        }
        let type = {};
        if (align || justify) {
            type = {type: 'flex'};
        }
        if (border) {
            const sty = {
                borderLeft: '1px solid #eee',
                borderBottom: '1px solid #eee',
                borderRight: '1px solid #eee',
            };
            style = Object.assign(sty, style || {});
        }
        return (
            <div className={"c_card " + (className || '')} style={style2}>
                <Row className="c_card_title">{title}</Row>
                <Row {...type} align={align ? align : "top"} className="c_card_content"
                     justify={justify ? justify : "start"} style={style}>{children}</Row>
            </div>
        );
    }
}

Card.propTypes = {
    // title: PropTypes.string,    //标题
    children: PropTypes.node,    //子元素
    width: PropTypes.string,    //宽度
    height: PropTypes.string,   //高度
    align: PropTypes.string,   //子元素垂直对其方式
    justify: PropTypes.string,   //子元素水平排列方式
    style: PropTypes.object,   //自定义样式
    className: PropTypes.string,    //class
    border: PropTypes.bool,     //边框
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.jsx